import React, { Component } from "react";
import {
    IconButton,
    Grid,
    List,
    ListItemAvatar,
    Avatar,
    ListItemText,
    ListItem,
    MenuItem,
    FormControl,
    TextField,
    Button,
    InputLabel,
    Select,
} from "@material-ui/core";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { connect } from "react-redux";
import { hot } from "react-hot-loader";
import { getBroadcast, addBroadcast } from "./actions";
import WarningIcon from "@material-ui/icons/Warning";
import AddIcon from "@material-ui/icons/PlaylistAdd";
import ListIcon from "@material-ui/icons/List";
class NewsBroadcast extends Component {
    constructor(props) {
        super(props);
        props.getBroadcast();
        this.state = {
            newBroadcast: {
                warning_level_status: "Green",
                message: "",
            },
            setBroadcastModal: false,
            BroadcastListModal: false,
        };
    }
    setBackground(status) {
        if (status === "Green") {
            return "green";
        } else if (status === "Red") {
            return "red";
        } else if (status === "Yellow") {
            return "yellow";
        } else {
            return "white";
        }
    }
    setFontcolor(status) {
        if (status === "Green") {
            return "white";
        } else if (status === "Red") {
            return "white";
        } else {
            return "black";
        }
    }

    render() {
        const { sm, md, lg, activeBroadcast, broadcasts } = this.props;

        return (
            <Grid item sm={sm} md={md} lg={lg}>
                <div
                    style={{
                        position: "relative",
                        background: this.setBackground(
                            activeBroadcast.warning_level_status
                        ),
                        minWidth: "100%",
                        minHeight: "60px",
                        height: "100%",
                        padding: 0,
                        margin: 0,
                        boxShadow:
                            "0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)",
                    }}
                >
                    <div
                        style={{
                            position: "relative",
                            float: "left",
                            background: "rgba(0,0,0,.15)",
                            width: "60px",
                            minHeight: "100%",
                            height: "100%",
                            lineHeight: "100%",
                        }}
                    >
                        <WarningIcon
                            style={{
                                color: this.setFontcolor(
                                    activeBroadcast.warning_level_status
                                ),
                                textAlign: "center",
                                position: "relative",
                                display: "block",
                                margin: "16 auto",
                            }}
                        />
                    </div>
                    <div
                        style={{
                            position: "relative",
                            width: "calc(100% - 60px)",
                            minHeight: "60px",
                            float: "right",
                            margin: 0,
                            padding: 6,
                            paddingTop: 14,
                            color: this.setFontcolor(
                                activeBroadcast.warning_level_status
                            ),
                            fontSize: 20,
                        }}
                    >
                        <Grid
                            container
                            spacing={0}
                            style={{ width: "100%", height: "100%" }}
                        >
                            <Grid item sm={12} md={12} lg={11} xl={11}>
                                <p
                                    style={{
                                        position: "relative",

                                        width: "70%",
                                        display: "inline",
                                        height: "100%",
                                        color: this.setFontcolor(
                                            activeBroadcast.warning_level_status
                                        ),
                                    }}
                                >
                                    <span>
                                        {activeBroadcast.timestamp + "     "}
                                    </span>
                                    <span>{`Status warning: ${
                                        activeBroadcast.message
                                            ? activeBroadcast.message
                                            : "N/A"
                                    }`}</span>{" "}
                                </p>
                            </Grid>
                            <Grid item sm={12} md={12} lg={1} xl={1}>
                                <div style={{ height: "100%" }}>
                                    {this.props.canCreate && (
                                        <IconButton
                                            style={{
                                                display: "inline",
                                                marginTop: "-7px",
                                            }}
                                            onClick={() => {
                                                this.setState({
                                                    setBroadcastModal: true,
                                                });
                                            }}
                                            aria-label="Add Broadcast"
                                        >
                                            <AddIcon />
                                        </IconButton>
                                    )}
                                    <IconButton
                                        style={{
                                            display: "inline",
                                            marginTop: "-7px",
                                        }}
                                        aria-label="Lists"
                                        onClick={() => {
                                            this.setState({
                                                BroadcastListModal: true,
                                            });
                                        }}
                                    >
                                        <ListIcon />
                                    </IconButton>
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </div>

                <Modal isOpen={this.state.BroadcastListModal}>
                    <ModalHeader>Broadcast List</ModalHeader>
                    <ModalBody>
                        <List>
                            {broadcasts &&
                                Object.keys(broadcasts).map((timestamp) => {
                                    return (
                                        <ListItem
                                            key={timestamp}
                                            style={{
                                                padding: 24,
                                                background:
                                                    broadcasts[timestamp]
                                                        .warning_level_status,
                                            }}
                                        >
                                            <ListItemAvatar>
                                                <Avatar
                                                    style={{
                                                        background: "white",
                                                        border:"1px solid black",
                                                        color:
                                                            broadcasts[
                                                                timestamp
                                                            ]
                                                                .warning_level_status,
                                                    }}
                                                >
                                                    <WarningIcon />
                                                </Avatar>
                                            </ListItemAvatar>
                                            <ListItemText
                                                disableTypography
                                                style={{
                                                    color: this.setFontcolor(
                                                        activeBroadcast.warning_level_status
                                                    ),
                                                    fontSize: 18,
                                                }}
                                                primary={`Status warning: ${
                                                    broadcasts[timestamp]
                                                        .message
                                                        ? broadcasts[timestamp]
                                                              .message
                                                        : "N/A"
                                                }`}
                                                secondary={" : " + timestamp}
                                            />
                                        </ListItem>
                                    );
                                })}
                        </List>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            variant="contained"
                            onClick={() =>
                                this.setState({
                                    BroadcastListModal: false,
                                })
                            }
                        >
                            Cancel
                        </Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.setBroadcastModal}>
                    <ModalHeader>Update News Broadcast</ModalHeader>
                    <ModalBody>
                        <FormControl style={{ width: "80%" }}>
                            <InputLabel>Warning Level Status</InputLabel>
                            <Select
                                value={
                                    this.state.newBroadcast[
                                        "warning_level_status"
                                    ]
                                }
                                onChange={(event) => {
                                    let newBroadcast = {
                                        ...this.state.newBroadcast,
                                        warning_level_status:
                                            event.target.value,
                                    };
                                    this.setState({ newBroadcast });
                                }}
                            >
                                <MenuItem
                                    style={{ background: "green" }}
                                    value={"Green"}
                                    key={"green"}
                                >
                                    Green
                                </MenuItem>
                                <MenuItem
                                    style={{ background: "yellow" }}
                                    value={"Yellow"}
                                    key={"yellow"}
                                >
                                    Yellow
                                </MenuItem>
                                <MenuItem
                                    style={{ background: "red" }}
                                    value={"Red"}
                                    key={"red"}
                                >
                                    Red
                                </MenuItem>
                            </Select>
                        </FormControl>
                        <FormControl style={{ width: "80%" }}>
                            <TextField
                                value={this.state.newBroadcast["message"]}
                                label={"Message"}
                                onChange={(event) => {
                                    let newBroadcast = {
                                        ...this.state.newBroadcast,
                                        message: event.target.value,
                                    };
                                    this.setState({ newBroadcast });
                                }}
                            />
                        </FormControl>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            variant="contained"
                            onClick={() =>
                                this.setState({
                                    setBroadcastModal: false,
                                })
                            }
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                this.props.addBroadcast(
                                    this.state.newBroadcast
                                );
                                this.setState({ setBroadcastModal: false });
                            }}
                            disabled={
                                this.state.newBroadcast["message"] === ""
                                    ? true
                                    : false
                            }
                        >
                            Update
                        </Button>
                    </ModalFooter>
                </Modal>
            </Grid>
        );
    }
}

export default hot(module)(
    connect(
        (store, props) => {
            const { selectors } = props;
            const { selectBroadcasts, selectActiveBroadcast } = selectors;
            return {
                broadcasts: selectBroadcasts(store),
                activeBroadcast: selectActiveBroadcast(store),
            };
        },
        { getBroadcast, addBroadcast }
    )(NewsBroadcast)
);
